import React, { useState } from 'react';
import { LeadTable } from '../components/leads/LeadTable';
import { filterLeads, exportLeadsToCSV } from '../utils/leadHelpers';
import { SearchInput } from '../components/common/SearchInput';
import { Download, Filter } from 'lucide-react';

export function Leads({ leads, onSelectLead, onUpdateLead, onUpdateStatus, onUpdateAssignee, onDeleteLead, onAddNote, showToast }) {
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  const filtered = filterLeads(leads, {
    search,
    status: statusFilter
  });

  const handleExportCSV = () => {
    const success = exportLeadsToCSV(filtered);
    if (success && showToast) {
      showToast('Exported leads to CSV file', 'success');
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      {/* Page Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
        <div>
          <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#09090B' }}>Leads & Enquiries Management</h2>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <button
            type="button"
            onClick={handleExportCSV}
            style={{
              height: '36px',
              padding: '0 14px',
              borderRadius: '6px',
              border: '1px solid #D4D4D8',
              backgroundColor: '#FFFFFF',
              color: '#09090B',
              fontSize: '13px',
              fontWeight: 500,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            <Download size={14} color="#71717A" />
            <span>Export CSV</span>
          </button>
        </div>
      </div>

      {/* Filter Bar */}
      <div className="card" style={{ padding: '14px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
        <div style={{ width: '280px' }}>
          <SearchInput value={search} onChange={setSearch} placeholder="Search lead name, company or ID..." />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontSize: '12.5px', color: '#71717A', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '4px' }}>
            <Filter size={13} /> Filter Status:
          </span>
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            style={{
              height: '34px',
              padding: '0 12px',
              borderRadius: '6px',
              border: '1px solid #D4D4D8',
              fontSize: '12.5px',
              backgroundColor: '#FFFFFF',
              color: '#09090B',
              outline: 'none',
              cursor: 'pointer',
              fontWeight: 500
            }}
          >
            <option value="all">All Lead Statuses ({leads.length})</option>
            <option value="qualified">Qualified</option>
            <option value="contacted">Contacted</option>
            <option value="site_visit">Site Visit</option>
            <option value="proposal">Proposal</option>
            <option value="leased">Leased</option>
          </select>
        </div>
      </div>

      {/* Main Hand-Crafted Table */}
      <LeadTable
        leads={filtered}
        onSelectLead={onSelectLead}
        onUpdateLead={onUpdateLead}
        onUpdateStatus={(id, s) => {
          onUpdateStatus(id, s);
          showToast(`Updated status to ${s.toUpperCase()}`, 'success');
        }}
        onUpdateAssignee={(id, a) => {
          onUpdateAssignee(id, a);
          showToast(`Assigned lead to ${a}`, 'info');
        }}
        onDeleteLead={(id) => {
          if (onDeleteLead) onDeleteLead(id);
          showToast('Lead deleted from pipeline', 'info');
        }}
        showToast={showToast}
      />
    </div>
  );
}
